import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router, Routes } from '@angular/router';
import { TENANTSINTERFACE } from '@fitness-force/models';
import { DataGridComponent, NoComponentComponent } from '@fitness-force/grid';
import {
  AuthguardService,
  RouteStateService,
  SharedModule,
  TenantResolverService
} from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';
import { TENANTS_INFO, ROUTER_STATE } from '../../../state/app.state';
import { TenantService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DividerModule } from 'primeng/divider';
import { TranslateService } from '@ngx-translate/core';
import { SidebarModule } from 'primeng/sidebar';
import { AppErrors } from '@fitness-force/errors';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { DateFormatedComponent } from '@fitness-force/grid-utility';
import { ContactSource, ContactStatus } from '@fitness-force/enum';
// import { ActionsComponent } from 'libs/grid-utility/action/src/lib/actions/actions.component';
import { ActionsComponent } from '@fitness-force/grid-utility/action';
import { ProspectFormComponent } from '@fitness-force/core';

@Component({
  selector: 'fitness-force-contacts-list',
  templateUrl: './contacts-list.component.html',
  styleUrls: ['./contacts-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MessageService],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DataGridComponent,
    StyleClassModule,
    DropdownModule,
    ButtonModule,
    RippleModule,
    StyleClassModule,
    SelectButtonModule,
    InputTextModule,
    ButtonModule,
    BreadcrumbModule,
    DividerModule,
    SidebarModule,
    ToastModule,
    OverlayPanelModule,
    SharedModule,
    CalendarModule,
    ProspectFormComponent
]
})

export class ContactsListComponent implements OnInit {
  currentUrl = '';
  getAccessTenantList$: Observable<any> | any;
  tenantId = 0;
  columns: any = new BehaviorSubject([]);
  tableData: any = new BehaviorSubject([]);
  selectedContact: any = new Map();
  contacts: any = new BehaviorSubject([]);
  showCalendar = false;
  allContacts$ = new BehaviorSubject<any>([]);
  calendarInput: Date | undefined;
  items: any[] = [];
  totalItems: any = new BehaviorSubject('');
  activefilters: any[] = [];
  contactParams: any = new Map();
  showBulkActionBar = false;
  selectAllContactsData = new BehaviorSubject(false);
  totalRecordLength = new BehaviorSubject({ totalPage: 10, totalItems: 10, currentPage: 0 });
  tableRecord: any = [];
  emptyStateComponent$ = new BehaviorSubject<any>(NoComponentComponent);
  loading = false;
  exporting = new BehaviorSubject(false);
  customFilterForm: UntypedFormGroup = new UntypedFormGroup({});
  showCreateProspectPopup = false;
  searchData = { name: '', email: '', mobile: '' };
  selectedContactData: any;
  

  sourceCollection = Object.entries(ContactSource)
  .filter((key) => typeof key[1] != 'number')
  .map(([key, value]) => ({ key, value }));

  statusCollection = Object.entries(ContactStatus)
  .filter((key) => typeof key[1] != 'number')
  .map(([key, value]) => ({ key, value }));

  constructor(private router: Router,
    private store: Store,
    private fb: UntypedFormBuilder,
    private timeService: TimeconversionService,
    public toastService: ToastMessageService,
    public cd: ChangeDetectorRef,
    private translate: TranslateService,
    private tenantService: TenantService,
    private routeStateService: RouteStateService
  ) {
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.router.events.subscribe((data: any) => {
      this.currentUrl = data.url;
    });
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.store.select(ROUTER_STATE).subscribe((rd) => {
      this.currentUrl = rd.url;
    });
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
        this.contactParams.set('PageNumber', { name: 'PageNumber', value: 1 });
        this.contactParams.set('PageSize', { name: 'PageSize', value: 10 });
        this.contactParams.set('ContactStatus', { name: 'ContactStatus', value: 'Open' });
        this.totalRecordLength.next({ totalPage: 10, totalItems: 10, currentPage: 0 });
        this.getAllContacts();
      }
    });

    this.customFilterForm = this.fb.group({
      source: [''],
      status: [''],
      converted_branch_id: [''],
      updated_from_date: [''],
      updated_to_date: ['']
    });
  }

  handleEvent(e: any) {
    if (e.selection) {
      this.selectedContact.set(e.data.data.index, e.data.data);
      this.showBulkActionBar = true;
    }
    else {
      this.selectedContact.delete(e.data.data.index);
      if (this.selectedContact.size > 0) {
        this.showBulkActionBar = true;
      } else {
        this.showBulkActionBar = false;
      }
    }
    this.allContacts$.next(this.getSelectedContactData);
  }

  handleSelectAll(selection: any) {
    if (selection.checked) {
      this.showBulkActionBar = true;
      this.tableRecord.forEach((value: any, index: any) => {
        this.selectedContact.set(index, value);
      });
    } else {
      this.showBulkActionBar = false;
      this.selectedContact.clear();
    }
    this.allContacts$.next(this.getSelectedContactData);
  }

  getAllContacts() {
    const params = this.getContactParams;
    this.loading = true;

    this.tenantService.getContactList(params).subscribe({
      next: (res: any) => {
          this.emptyStateComponent$.next(NoComponentComponent);
          this.gettableRecord(res.items || []);
          this.tableData.next(res.items || []);
          this.totalRecordLength.next({ 
            totalPage: res.total_pages, 
            totalItems: res.total_items, 
            currentPage: res.current_page 
          });
          this.totalItems.next(res.total_items);
          this.GetTableColumns();
          this.selectAllContactsData.next(false);
          this.loading = false;
          this.cd.detectChanges();
      },
      error: (error: AppErrors) => {
        this.toastService.showError(error);
        this.GetTableColumns();
        this.tableData.next([]);
        this.totalItems.next(0);
        this.totalRecordLength.next({ totalPage: 0, totalItems: 0, currentPage: 0 });
        this.loading = false;
        this.cd.detectChanges();
      }
    });
    // This is a placeholder - you'll need to implement the actual API service
    // this.contactService.getContacts(params, this.tenantId).subscribe((res: any) => {
    // Mocking the response for now
   
  }

  GetTableColumns() {
    this.translate
      .get([
        'CONTACTS.COLUMNS.CONTACT_NAME',
        'CONTACTS.COLUMNS.CONTACT_EMAIL',
        'CONTACTS.COLUMNS.CONTACT_PHONE',
        'CONTACTS.COLUMNS.SOURCE',
        'CONTACTS.COLUMNS.STATUS',
        'CONTACTS.COLUMNS.CREATED_DATE'
      ])
      .subscribe((translations) => {
        this.TableColumnsTransalation(translations);
      });
  }

  TableColumnsTransalation(translations: any) {
    this.columns.next([
      {
        title: translations['CONTACTS.COLUMNS.CONTACT_NAME'] || 'Contact Name',
        classes: 'py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'contact_name',
        type: 'default'
      },
      {
        title: translations['CONTACTS.COLUMNS.CONTACT_EMAIL'] || 'Email',
        classes: 'py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'contact_email',
        type: 'default'
      },
      {
        title: translations['CONTACTS.COLUMNS.CONTACT_PHONE'] || 'Phone',
        classes: 'py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'contact_mobile_number',
        type: 'default'
      },
      {
        title: translations['CONTACTS.COLUMNS.SOURCE'] || 'Source',
        classes: 'py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'contact_source',
        type: 'default'
      },
      {
        title: translations['CONTACTS.COLUMNS.STATUS'] || 'Status',
        classes: 'py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'contact_status',
        type: 'default'
      },
      {
        title: translations['CONTACTS.COLUMNS.CREATED_DATE'] || 'Created Date',
        classes: 'py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'contact_created_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'contact_created_date', format: 'defaultformat', applytimezone: true },
        },
      },
      {
        title: '',
        classes: 'py-2 text-600 white-space-nowrap',
        sortable: false,
        filterable: false,
        dataProperty: null,
        type: 'component',
        data: { 
          name: ActionsComponent,
          additionData: true,
          aData: [
            'convertContact'
          ] 
        }
      }
    ]);
  }

  gettableRecord(items: any) {
    return this.tableRecord = items;
  }

  fetchNextSetData(e: any) {
    this.contactParams.set('PageNumber', { name: 'PageNumber', value: e.pn });
    this.contactParams.set('PageSize', { name: 'PageSize', value: e.ps });
    this.gettableRecord([]);
    this.selectedContact.clear();
    this.showBulkActionBar = false;
    this.getAllContacts();
  }

  filterBySource(source: string) {
    if (source) {
      this.contactParams.set('ContactSource', { name: 'ContactSource', value: source });
    } else {
      this.contactParams.delete('ContactSource');
    }
    this.getAllContacts();
  }

  filterByStatus(status: string) {
    if (status) {
      this.contactParams.set('ContactStatus', { name: 'ContactStatus', value: status });
    } else {
      this.contactParams.delete('ContactStatus');
    }
    this.getAllContacts();
  }

  applyFilter(form: FormGroup) {
    if (form.controls.updated_from_date.value && form.controls.updated_to_date.value) {
      this.contactParams.set('ContactUpdatedDateFrom', { 
        name: 'ContactUpdatedDateFrom', 
        value: this.timeService.ConvertLocalDateTimeToUTC(form.controls.updated_from_date.value) 
      });
      this.contactParams.set('ContactUpdatedDateTo', { 
        name: 'ContactUpdatedDateTo', 
        value: this.timeService.ConvertLocalDateTimeToUTC(this.timeService.getEndOfDay(form.controls.updated_to_date.value)) 
      });
    }
    
    if (form.controls.source.value) {
      this.contactParams.set('ContactSource', { name: 'ContactSource', value: form.controls.source.value.value });
    }
    
    if (form.controls.status.value) {
      this.contactParams.set('ContactStatus', { name: 'ContactStatus', value: form.controls.status.value.value });
    }
    
    this.getAllContacts();
  }

  resetFilter() {
    this.customFilterForm.reset();
    this.contactParams.delete('ContactSource');
    this.contactParams.delete('ContactStatus');
    this.contactParams.set('PageNumber', { name: 'PageNumber', value: 1 });
    this.contactParams.set('PageSize', { name: 'PageSize', value: 10 });
    this.totalRecordLength.next({ totalPage: 10, totalItems: 10, currentPage: 0 });
    this.getAllContacts();
  }

  onGridAction(event: any) {
    if (event && event.action === "convertContact") {
      this.selectedContactData = event.columnData;
      this.searchData = {
        name: event.columnData.contact_name,
        email: event.columnData.contact_email,
        mobile: event.columnData.contact_mobile_number
      };
      this.showCreateProspectPopup = true;
    }
  }

  selectTenants(event: any) {
    if(event.length > 0) {
      this.ConvertedBranchId.setValue(event);
      this.contactParams.delete('ContactConvertedBranchId');
      this.contactParams.set('ContactConvertedBranchId', { name: 'ContactConvertedBranchId', value: event.map((item: any) => item.id) });
    } else {
      this.ConvertedBranchId.setValue(null);
      this.contactParams.delete('ContactConvertedBranchId');
    }
    this.getAllContacts();
  }

  hidePopup(event: any) {
    this.showCreateProspectPopup = false;
    if(event && event > 0) {
      this.getAllContacts();
    }
  }

  proceedToSignup(event: any) {
    this.showCreateProspectPopup = false;
  }

  GoToClientDetails(event: any) {
    this.showCreateProspectPopup = false;
  }

  ExportData() {
    this.contactParams.delete('PageNumber');
    this.contactParams.delete('PageSize');
    this.contactParams.set('PageNumber', { name: 'PageNumber', value: 1 });
    this.contactParams.set('PageSize', { name: 'PageSize', value: 99999999 });
    const params = this.getContactParams;
    this.exporting.next(true);
    
    // This is a placeholder - you'll need to implement the actual export service
    // this.contactExportService.exportContacts(params, this.tenantId).subscribe({
    //   next: (urlObj: { url: string }) => {
    //     this.reportFilterService.downloadFile(urlObj.url).subscribe(res => {
    //       this._FileSaverService.save(res, 'contacts' + new Date().getTime() + "." + EXCEL_EXTENSION);
    //       this.exporting.next(false);
    //     });
    //   },
    //   error: (error: AppErrors) => {
    //     this.exporting.next(false);
    //     this.toastService.showError(error);
    //     this.cd.detectChanges();
    //   },
    // });
    
    // Mock implementation for now
    setTimeout(() => {
      this.exporting.next(false);
      this.toastService.showSuccess("Export feature will be implemented soon.");
      this.cd.detectChanges();
    }, 1500);
  }

  get getContactParams(): Array<any> {
    return [...this.contactParams.values()];
  }

  get getSelectedContactData(): Array<any> {
    return [...this.selectedContact.values()];
  }

  get ContactIds(): number[] {
    return this.getSelectedContactData.map((o: any) => { return o.contact_id });
  }

  get SelectedSource(): UntypedFormControl {
    return this.customFilterForm.get('source') as UntypedFormControl;
  }

  get SelectedStatus(): UntypedFormControl {
    return this.customFilterForm.get('status') as UntypedFormControl;
  }

  get ConvertedBranchId(): UntypedFormControl {
    return this.customFilterForm.get('converted_branch_id') as UntypedFormControl;
  }
}

const routes: Routes = [
  {
    path: '',
    component: ContactsListComponent,
    canActivate: [AuthguardService],
    resolve: { data: TenantResolverService },
    data: {
      breadcrumb: 'Contacts List',
      title: "Contacts"
    },
  },
];
